/* globals $H */

var _ = require('lodash');

var ubBanzai = window.ubBanzai;

var FieldCleaner = function(model, fieldAttributeTypes) {
  this.fieldAttributeTypes = fieldAttributeTypes;
  this.model = model;
};
FieldCleaner.prototype =  {

  // TODO: add breakpoint aware version
  cleanField: function(field) {
    this._cleanFields([field.id]);
  },

  cleanInvalidFields: function() {
    if (ubBanzai.features.isBetterFieldCleanEnabled()) {
      this.cleanInvalidFieldsByBreakpoint();
    } else {
      this._cleanFields(this._findInvalidFields());
    }
  },

  cleanInvalidFieldsByBreakpoint: function() {
    _.each(this.model.element.page.breakpoints, this._cleanInvalidFieldsByBreakpoint.bind(this));
  },

  // private:
  _getValidBreakpointAttributeTypes: function(breakpoint) {
    return _.select(this.fieldAttributeTypes, function(type) {
      return this.model && this.model.existsByBreakpoint(type, breakpoint);
    }, this);
  },

  _getBreakpointFieldIds: function(breakpoint) {
    return _.map(this._getValidBreakpointAttributeTypes(breakpoint), function(type) {
      return _.keys(this.model.safeGet(type, breakpoint));
    }, this).flatten().uniq();
  },

  _cleanInvalidFieldsByBreakpoint: function(breakpoint) {
    //TODO: clean up
    var model = this.model;

    var breakpointFieldsIds = this._getBreakpointFieldIds(breakpoint);

    var visibleFieldIds = _.pluck(model.safeGet('content.fields', breakpoint), 'id');

    var invalidFieldIds = _.reject(breakpointFieldsIds, function(fieldId) {
      return _.include(visibleFieldIds,fieldId);
    }).flatten().uniq();

    var invalidFields = _.map(this.fieldAttributeTypes, function(type) {
      return _.map(invalidFieldIds, function(fieldId) {
        return type + '.' + fieldId;
      });
    }).flatten();

    invalidFields
      .filter(function(fieldId){
        return model.existsByBreakpoint(fieldId, breakpoint);
      })
      .each(function(fieldId) {
        if(breakpoint.default) {
          model.deleteAttr(fieldId);
        } else {
          model.forceDeleteAttrOnMobileBreakpoint(fieldId);
        }
      });
  },

  _findAccessorsUsedBy: function(ids) {
    var model               = this.model
      , fieldAttributeTypes = this.fieldAttributeTypes;

    return ids.map(function(id) {
      return fieldAttributeTypes.map(function(node) {
        return node + "." + id;
      });
    })
    .flatten()
    .select(function(accessor) {
      return model && model.exists(accessor);
    });
  },

  _cleanFields: function(fieldIds) {
    var model = this.model;
    this._findAccessorsUsedBy(fieldIds).each(function(accessor){
      model.deleteAttr(accessor);
    });
  },

  _getFields: function() {
    return this.model.exists('content.fields') ? this.model.get('content.fields') : [];
  },

  _findInvalidFields: function() {
    var self = this;

    var visibleFieldIds = this._getFields().map(function(field) {
      return field.id;
    });

    var allFieldIds = this.fieldAttributeTypes.collect(function(node) {
      return $H(self.model.modelData[node]).keys();
    }).flatten().uniq();

    return allFieldIds.reject(function(fieldId){
      return visibleFieldIds.include(fieldId);
    }).flatten().uniq();
  }
};

module.exports = FieldCleaner;



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/modules/lp-form/form_element/field_cleaner.js
// module id = 568
// module chunks = 0 1